export default __webpack_public_path__ + "static/media/mortarboard-active.b2797644.svg";